import data from '@emoji-mart/data';
import { init } from 'emoji-mart';
init({ data });
